import { FC, PropsWithChildren } from "react";

import { DateTime } from "@bps/date-time";
import { Heading, Stack, Text } from "@bps/fluent-ui";

import { FormDisplaySettings } from "../hooks/useFormApi.types";

const getField = (field: string, titleFields: Record<string, string>) => {
  const titleKeys = titleFields && (Object.keys(titleFields) as string[]);
  const keyIndex = titleKeys && titleKeys.findIndex(x => x === field);
  if (typeof keyIndex === "number" && keyIndex >= 0) {
    const values = titleFields && (Object.values(titleFields) as string[]);
    return values && values[keyIndex];
  }
  return null;
};

interface FormHeaderProps extends FormDisplaySettings {
  titleFields?: Record<string, string>;
  expiry?: DateTime;
}

export const FormLayoutWrapper: FC<PropsWithChildren<FormHeaderProps>> = ({
  titleFields,
  expiry,
  headerImageUrl,
  footerImageUrl,
  headerText,
  footerText,
  children
}) => {
  const titles: string[] = [];
  if (titleFields) {
    const patientName = getField("PatientName", titleFields);
    patientName && titles.push(`Generated for : ${patientName}`);

    const startDate = getField("StartTime", titleFields);
    const practitioner = getField("Practitioner", titleFields);

    if (startDate && practitioner) {
      titles.push(`Appointment: on ${startDate} with ${practitioner}`);
    } else {
      if (startDate) {
        titles.push(`Appointment: on ${startDate} `);
      }
      if (practitioner) {
        titles.push(`Appointment: with ${practitioner}`);
      }
    }
    if (titles.length && expiry) {
      titles.push(`Expiring on: ${expiry?.toFormat("dd LLLL yyyy")}`);
    }
  }

  const Expiry: FC = () =>
    expiry ? (
      <Text>This form expires on {expiry?.toFormat("dd LLLL yyyy")}</Text>
    ) : null;

  return (
    <>
      {headerImageUrl && (
        <img
          alt="form header"
          src={headerImageUrl}
          className="bp-header-footer"
          style={{
            maxWidth: "90vw",
            maxHeight: "25vh",
            objectFit: "scale-down"
          }}
        />
      )}
      {headerText && (
        <Heading
          variant="heading"
          className="bp-header-footer"
          styles={{ root: { marginTop: 8, marginBottom: 0 } }}
        >
          {headerText}
        </Heading>
      )}
      {titles ? (
        <Stack>
          {titles.map(x => (
            <Text key={x}>{x}</Text>
          ))}
        </Stack>
      ) : (
        <Expiry />
      )}
      {children}
      {footerText && (
        <Text
          className="bp-header-footer"
          styles={{ root: { marginBottom: 16, display: "block" } }}
        >
          {footerText}
        </Text>
      )}
      {footerImageUrl && (
        <img
          alt="form footer"
          src={footerImageUrl}
          className="bp-header-footer"
          style={{
            maxWidth: "90vw",
            maxHeight: "25vh",
            objectFit: "scale-down"
          }}
        />
      )}
    </>
  );
};
